import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

// Own constants/actions/components
import ButtonFloat from 'components/button-float';
import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import CarouselContainer from 'containers/carousel';
import FilterExperiencesContainer from 'containers/filter-experiences';
// import HowWorkSection from 'containers/how-work-section';
import ExperienciesInspireSection from 'containers/experiences-inspire';
import NewsLetterContainer from 'containers/newsletter';
import BannerPromotion from 'containers/banner';
import { items } from 'services/selectors/shopping-cart';
import ExperienciesSection from '../../containers/experiences-recommend';

const HomePage = () => {
  const itemsCart = useSelector(items);

  /**
   * Create sesion in Experiencies App.
   * Use ssoToken when login success
  */
  useEffect(() => {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const paramToken = url.searchParams.get('ssoToken');

    if (paramToken !== null && Cookies.get('frontSession') === undefined) {
      const inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000);
      Cookies.set('frontSession', 'experiencias', {
        expires: inTwentyMinutes,
      });
      window.location.href = `${window.location.origin}/#/mis-experiencias`;
    }
  }, []);

  return (
    <div>
      <ButtonFloat number={itemsCart.length} />
      <HeaderContainer />
      <CarouselContainer />
      <FilterExperiencesContainer />
      <ExperienciesSection />
      {/* <HowWorkSection /> */}
      <ExperienciesInspireSection maxResults={3} />
      <BannerPromotion />
      <NewsLetterContainer />
      <FooterContainer />
    </div>
  );
};

export default HomePage;
